const INITIAL_STATE = { 
    registro: {}, 
    modoTela: 'lista', 
    lista: [], 
    listaVeiculo: [],
    listaOficina: [],
    listaTipo: [],
    listaItem: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'MANUTENCAO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'MANUTENCAO_LISTADO':
            return { ...state, lista: action.payload.data };

        case 'MANUTENCAO_TIPO_SELECT_LISTADO':
			return {
				...state,
				listaTipo: action.payload.data
            };

        case 'MANUTENCAO_VEICULO_SELECT_LISTADO':
			return {
				...state,
				listaVeiculo: action.payload.data
            };

        case 'MANUTENCAO_OFICINA_SELECT_LISTADO':
			return {
				...state,
				listaOficina: action.payload.data
            };
        
        case 'MANUTENCAO_ITEM_VEICULO_SELECT_LISTADO':
			return {
				...state,
				listaItem: action.payload.data
            };

        default:
            return state;
    }
}
